import type { WidgetDefinition } from "@nexus/widget-sdk";
import { manifest, Component, defaultConfig } from ".";

export const definition: WidgetDefinition = {
  id: "event-cdn-thieves",
  module: { manifest, Component, defaultConfig },
  catalog: {
    description: "One protected event's CDN-theft infrastructure providers.",
    domain: "reports",
    visual: "Carousel",
    purposes: ["reporting"],
    reportEdition: true,
    audiences: ["analyst", "client"],
  },
  layout: { skeleton: "cards" },
  defaultLayoutClassName: "col-span-12",
};
